<template>
  <v-avatar @click.stop="clickPlayIt" v-if="avatar">
    <v-img
      v-if="image"
      :src="image"
      class="fid-avatar-width left"
    ></v-img>
    <v-icon :color="color" v-else>
      {{ icon }}
    </v-icon>
  </v-avatar>
    <v-img v-else-if="image && isFilm"
     class="mt-2 mb-1 left"
     :src="image"
     :aspect-ratio="16/9"
     :width="imageWidth"
     :height="imageWidth/16*9"
     @click.stop="clickPlayIt"
  ></v-img>
  <v-img v-else-if="image"
      :src="image"
      :width="imageWidth"
      class="mr-3 mb-2 left"
    ></v-img>
  <v-icon v-else :color="color">
    {{ icon }}
  </v-icon>
</template>
<script>
import { getIcon, getIconColor, settings } from '@/js/store'
export default {
  props: {
    image: String,
    rowType: String,
    avatar: Boolean,
    playIt: String
  },
  methods: {
    clickPlayIt () {
      this.$emit(this.playIt)
    },
    bigEnough () {
      return this.$vuetify.breakpoint.mdAndUp
    }
  },
  computed: {
    isFilm () {
      return this.rowType === 'film' || this.rowType === 'vimeofilm'
    },
    avatarWidth () {
      return '100%'
    },
    imageWidth () {
      return (this.bigEnough ? settings.dimensions.playerWidth : settings.dimensions.playerWidthSm) + 'px'
    },
    icon () {
      return getIcon(this.rowType)
    },
    color () {
      return getIconColor(this.rowType)
    }
  }
}
</script>
